import React, { Component } from 'react';

//styles
import './sectionTwo.scss';
import '../../static/fonts/opensanshebrew/stylesheet.css'
import CountUp from 'react-countup';
import TrackVisibility from 'react-on-screen';
import CountUpOnView from '../CountUpOnView/CountUpOnView'

const Star = ({ isVisible }) => {
    return <div className={isVisible ? "star active" : "star"}></div>
}

class SectionTwo extends Component {
    componentDidMount() {
    }

    render() {
        return (
            <div id="section2" className="section2-container">
                <div className="desc-container">
                    <div className="title"></div>
                    {/* <div className="desc">המהפכה האיסלאמית באיראן הייתה מהאירועים הדרמטיים ביותר במאה ה-20. בעקבותיה הפכה איראן ממדינה מלוכנית-חילונית ופרו-מערבית שבה שולט השאה מוחמד רזא פהלווי, לתיאוקרטיה איסלאמית המתנגדת בחריפות לערכי המערב, תחת הנהגת האייתוללות חומייני וחמינאי.</div> */}
                    <div className="desc">בפברואר 79', כשמטוסו של חומייני נשק לאדמת טהרן, איראן החילונית נמחקה, וארץ חדשה נולדה. ארץ של דיכוי, של פרנויה, של איסלאם – ארץ שהייתה לנו ידידה, ועכשיו רואה בנו שטן. מאין באה השנאה? איך צמח הטרור? ומתי תצא איראן מחושך לאור? <br/>פרויקט מיוחד<br/><span>עורך: אייל להמן</span></div>
                </div>
                <div className="map-container">
                    <div className="map-image"></div>
                    <div className="map-desc-container">
                        <div className="map-title">איראן היא המדינה ה-17 בגודלה, ושטחה </div>
                        <div className="map-desc">
                            <CountUpOnView start={1500000} end={1648195} suffix={"קמ\"ר"} prefix={""}/>
                        </div>
                    </div>
                </div>
                <div className="star-container">
                    <div>
                        <TrackVisibility partialVisibility once>
                            <Star />
                        </TrackVisibility>
                    </div>
                </div>
            </div>
        );
    }
}

export default SectionTwo;


// WEBPACK FOOTER //
// ./src/Components/SectionTwo/SectionTwo.js